 
<div class="py-2">
	<div class="container">
		<!--div class="row">
		<div class="col-md-3 offset-md-9">
			<form class="form-inline">
			<div class="input-group">
				<input type="text" class="form-control" placeholder="Username">
				<div class="input-group-append">
				<button class="btn btn-primary" type="button">Filter</button>
				</div>
			</div>
			</form>
		</div>
		</div-->
		<div class="row">
		<!--div class="col-md-8  py-1">
		
		<div *ngIf="rtnStatusData && rtnStatusData.success == true" class="alert alert-success">
			{{ rtnStatusData.message }}
		</div>
			<table class="table">
			<thead>
				<tr>
				<th>#</th>
				<th>Account Name</th>
				<th>Type</th>
				<th>Account Details</th>
				<th>Account Domain</th>
				<th>Action</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let adata of accountData; let i = index">
				<td>#{{i + 1}}</td>
				<td>{{ adata.accountName }}</td>
				<td>
					<p *ngFor="let rtype of registrationAccountTypes" >
					<span class="badge" *ngIf="rtype.id == adata.registrationType">{{rtype.type}}</span> 
					</p>
				</td>
				<td>{{ adata.accountDetails }}</td>
				<td>{{ adata.accountDomain }}</td>
				<td> <i class="fa d-inline fa-lg fa-edit " (click)="accountEdit(adata._id)" ></i> <i class="fa d-inline fa-lg fa-trash-o" (click)="deleteAccount(adata._id)"></i></td>
				</tr>              
			</tbody>
			</table>
			
		</div-->
		<div class="col-md-12 py-1">
			<form (ngSubmit)="onSubmit(accountForm, model.id)" #accountForm="ngForm">
			<div *ngIf="rtnData && rtnData.success == true" class="alert alert-success">
					{{ rtnData.message }}
				</div>
			<div class="form-group"> <label for="accountName">Account Name</label>
				<input type="text" oninput="this.value = this.value.toLowerCase()" required class="form-control" id="accountName" placeholder="Enter Account Name" name="accountName" #accountName="ngModel" [(ngModel)]="model.accountName"> 
				<div *ngIf="rtnData && rtnData.message.accountName" class="alert alert-danger">
					{{rtnData.message.accountName}}
				</div>
			</div>
				
				<div class="form-group"> <label for="registrationType">Registration Type</label>
				<select class="form-control" id="registrationType"
					required
					[(ngModel)]="model.registrationType" name="registrationType"
					#registrationType="ngModel">
					<option value="">Select Registration Type</option>
					<option *ngFor="let regtype of registrationAccountTypes" [value]="regtype.id">{{regtype.type}}</option>
				</select>
				<div *ngIf="rtnData && rtnData.message.registrationType" class="alert alert-danger">
					{{rtnData.message.registrationType}}
				</div> 
			</div>
			
			
			<div class="form-group"> <label for="accountDetails">Account Details</label>
				<!--input type="text" required class="form-control" id="accountDetails" placeholder="Enter Account Details" name="accountDetails" #accountDetails="ngModel" [(ngModel)]="model.accountDetails"--> 
				<textarea required class="form-control" id="accountDetails" placeholder="Enter Account Details" name="accountDetails" #accountDetails="ngModel" [(ngModel)]="model.accountDetails"> </textarea>
				<div *ngIf="rtnData && rtnData.message.accountDetails" class="alert alert-danger">
					{{rtnData.message.accountDetails}}
				</div>
			</div>
				
				
			<div class="form-group"> <label for="accountDomain">Account Domain</label>
				<input type="url" required class="form-control" id="accountDomain" placeholder="Enter Account Domain" name="accountDomain" #accountDomain="ngModel" [(ngModel)]="model.accountDomain"> 
				<div *ngIf="rtnData && rtnData.message.accountDomain" class="alert alert-danger">
					{{rtnData.message.accountDomain}}
				</div>
				</div>
				
				<div class="text-right">
					<button type="submit" class="btn btn-primary">{{ (model.id)?"Update":"Create" }}</button>
					<button type="button" (click)="clearFormData()" class="btn btn-secondary">Cancel</button>
				</div>
			</form>
		</div>
		</div>
	</div>
</div> 